import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';

var Progress = function Progress(props) {
  var rtlStyle = {
    transform: 'scale(-1, 1)'
  };
  var _props$color = props.color,
      color = _props$color === void 0 ? 'currentColor' : _props$color,
      size = props.size,
      _props$dir = props.dir,
      dir = _props$dir === void 0 ? 'ltr' : _props$dir,
      style = props.style;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: dir === 'rtl' ? _extends({}, style, rtlStyle) : _extends({}, style)
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 3.98863C21 3.44262 20.5533 3 20.0024 3C19.4514 3 19.0048 3.44262 19.0048 3.98863V6.45824C17.3357 4.38132 14.7752 3.10238 11.9786 3.10238C7.35962 3.10238 3.55527 6.5588 3.05562 11.004C2.99408 11.5515 3.44665 12 3.99763 12C4.5486 12 4.98763 11.5507 5.06682 11.0055C5.55346 7.65466 8.46258 5.07963 11.9786 5.07963C14.2655 5.07963 16.3492 6.17886 17.638 7.94315L15.0143 7.94314C14.4633 7.94314 14.0166 8.38577 14.0166 8.93177C14.0166 9.47778 14.4633 9.9204 15.0143 9.9204L20.0024 9.9204C20.5533 9.9204 21 9.47778 21 8.93177V3.98863Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 20.0114C3 20.5574 3.44665 21 3.99762 21C4.54859 21 4.99525 20.5574 4.99525 20.0114V17.5418C6.66427 19.6187 9.22479 20.8976 12.0214 20.8976C16.6404 20.8976 20.4447 17.4412 20.9444 12.996C21.0059 12.4485 20.5533 12 20.0024 12C19.4514 12 19.0124 12.4493 18.9332 12.9945C18.4465 16.3453 15.5374 18.9204 12.0214 18.9204C9.73445 18.9204 7.65076 17.8211 6.36204 16.0569H8.98574C9.53671 16.0569 9.98336 15.6142 9.98336 15.0682C9.98336 14.5222 9.53671 14.0796 8.98574 14.0796L3.99762 14.0796C3.44665 14.0796 3 14.5222 3 15.0682V20.0114Z",
    fill: color
  }));
};

export { Progress };
